<script setup lang="ts">
const props = defineProps<{
    sourceBucket: string
    sourceData: Record<string, unknown>
    fieldPath: string
}>()

const reference = await useContentReference(props)
</script>

<template>
    <slot
        :label="reference.label.value"
        :image="reference.image.value"
    />
</template>
